import { render, staticRenderFns } from "./DebtorAccountPage.vue?vue&type=template&id=74e4ef71&"
import script from "./DebtorAccountPage.vue?vue&type=script&lang=js&"
export * from "./DebtorAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./DebtorAccountPage.vue?vue&type=style&index=0&id=74e4ef71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports